import React, { Fragment, useState } from "react";
import { Helmet } from "react-helmet";
import BoxShadow from "../../../Common/Components/BoxShadow";
import CommonFrom from "../../../Common/Components/Form";
import { FormSubmit } from "./Components/Services";

function Create({ isApp }) {
  const initialState = {
    loading: false,
  };
  const [state, setstate] = useState(initialState);

  const Handler = data => {
    setstate({ loading: true });
    FormSubmit(data).then(() => {
      setstate({
        loading: false,
      });
    });
  };
  return (
    <Fragment>
      <CommonFrom
        form={input}
        loading={state.loading}
        shadowClass={!isApp ? null : "shadow-none mt-4 appInputBox"}
        header={isApp ? null : "درخواست جدید"}
        textbtn="لیست درخواست ها"
        linkbtn="/User/Listnewitem"
        btnName="ثبت درخواست"
        submit={Handler}
        isApp={isApp}
      />
    </Fragment>
  );
}

export let input = [
  {
    label: "نام مجموعه",
    size: "col-md-4",
    classNames: "mt-2",
    placeholder: "",
    name: "form_details",
    keyname: "itemfullname",
    value: "",
  },
  {
    label: "آدرس مجموعه",
    size: "col-md-8",
    classNames: "mt-2",
    placeholder: "استان،شهرستان،ادرس دقیق",
    name: "form_details",
    keyname: "fullname",
    value: "",
  },
  {
    label: "نام و نام خانوادگی مدیر باشگاه",
    size: "col-md-4",
    classNames: "mt-2",
    placeholder: "",
    name: "form_details",
    keyname: "itemadminname",
    value: "",
  },
  {
    label: "نوع درخواست",
    size: "col-md-4",
    classNames: "mt-2",
    placeholder: "",
    name: "form_details",
    keyname: "typereq",
    input: "select",
    options: [
      { id: "me", name: "مالک باشگاه هستم" },
      { id: "affer", name: "پیشنهاد دهنده هستم" },
    ],
  },

  {
    label: "شماره تماس باشگاه",
    size: "col-md-4",
    classNames: "mt-2",
    placeholder: "همراه با کد استان",
    name: "form_details",
    keyname: "itemtel",
    value: "",
    type: "number",
  },
  {
    label: "شماره تماس مدیر باشگاه",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "form_details",
    keyname: "itemadmintel",
    value: "",
    type: "number",
  },
  {
    label: "رشته های ورزشی",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "بسکتبال،فوتبال و ...",
    name: "form_details",
    keyname: "sports",
    value: "",
  },
];

export default Create;
